import { render } from "./SolicitacaoForm.vue?vue&type=template&id=61b8f886"
import script from "./SolicitacaoForm.vue?vue&type=script&lang=js"
export * from "./SolicitacaoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__